import getLocalStorage from "./getLocalStorage";

const deleteLocalStorageItem = (key: string) => {
  const storage = getLocalStorage();
  if (!key || !storage) {
    return;
  }
  storage.removeItem(key);
};

export default deleteLocalStorageItem;
